import { render, staticRenderFns } from "./OsCreateLinksForm.vue?vue&type=template&id=66ffb69a&scoped=true"
import script from "./OsCreateLinksForm.vue?vue&type=script&lang=ts"
export * from "./OsCreateLinksForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffb69a",
  null
  
)

export default component.exports